if (!customElements.get('product-form')) {
	customElements.define(
	  'product-form',
	  class ProductForm extends HTMLElement {
		constructor() {
		  super();
  
		  this.form = this.querySelector('form');
		  if (this.form) {
		  this.form.querySelector('[name=id]').disabled = false;
		  this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
		  }
		  this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
		  this.submitButton = this.querySelector('[type="submit"]');
  
		  if (document.querySelector('cart-drawer') && this.submitButton) this.submitButton.setAttribute('aria-haspopup', 'dialog');
  
		  this.hideErrors = this.dataset.hideErrors === 'true';
		  const cartUpdateEvent = window.PUB_SUB_EVENTS?.cartUpdate
			|| (typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS.cartUpdate : null);
		  this.cartUpdateUnsubscriber = typeof subscribe === 'function' && cartUpdateEvent
			? subscribe(cartUpdateEvent, () => this.refreshCartQuantity())
			: null;
		  this.refreshCartQuantity();
		}

		disconnectedCallback() {
		  if (typeof this.cartUpdateUnsubscriber === 'function') this.cartUpdateUnsubscriber();
		}

		async refreshCartQuantity() {
		  const button = this.querySelector('[data-jsd-pdp-cart-variant]');
		  const label = button?.querySelector('[data-jsd-pdp-cart-label]');
		  const variantId = this.form?.querySelector('select[name="id"]')?.value
			|| this.form?.querySelector('[name="id"]')?.value;
		  if (!button || !label || !variantId || button.disabled) return;

		  button.dataset.jsdPdpCartVariant = variantId;
		  try {
			const response = await fetch(`${window.routes?.cart_url || '/cart'}.js`, {
			  credentials: 'same-origin',
			  headers: { Accept: 'application/json' },
			});
			if (!response.ok) return;
			const cart = await response.json();
			const quantity = (cart.items || [])
			  .filter((item) => String(item.variant_id) === String(variantId))
			  .reduce((total, item) => total + (Number(item.quantity) || 0), 0);
			label.textContent = quantity > 0 ? `Add To Cart (${quantity})` : 'Add To Cart';
			button.setAttribute('aria-label', quantity > 0
			  ? `Add To Cart. ${quantity} currently in cart`
			  : 'Add To Cart');
		  } catch (error) {
			console.warn('PDP cart quantity could not be refreshed.', error);
		  }
		}

		animateCartConfirmation() {
		  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

		  if (this.submitButton?.matches('.product-form__submit, .button-add-card')) {
			this.submitButton.classList.remove('is-cart-confirmed');
			void this.submitButton.offsetWidth;
			this.submitButton.classList.add('is-cart-confirmed');
			window.setTimeout(() => this.submitButton?.classList.remove('is-cart-confirmed'), 450);
		  }

		  window.setTimeout(() => {
			document.querySelectorAll('.cart-count-bubble').forEach((bubble) => {
			  bubble.classList.remove('is-cart-confirmed');
			  void bubble.offsetWidth;
			  bubble.classList.add('is-cart-confirmed');
			  window.setTimeout(() => bubble.classList.remove('is-cart-confirmed'), 450);
			});
		  }, 80);
		}
  
		onSubmitHandler(evt) {
		  evt.preventDefault();
		  if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
  
		  this.handleErrorMessage();
  
		  this.submitButton.setAttribute('aria-disabled', true);
		  this.submitButton.classList.add('loading');
  
		  if (this.querySelector('.loading__spinner')) {
			this.querySelector('.loading__spinner').classList.remove('hidden');
		  }
  
		  const config = fetchConfig('javascript');
		  config.headers['X-Requested-With'] = 'XMLHttpRequest';
		  delete config.headers['Content-Type'];
  
		  const formData = new FormData(this.form);
		  if (this.cart) {
			formData.append(
			  'sections',
			  this.cart.getSectionsToRender().map((section) => section.id)
			);
			formData.append('sections_url', window.location.pathname);
			this.cart.setActiveElement(document.activeElement);
		  }
		  config.body = formData;
  
		  fetch(`${routes.cart_add_url}`, config)
			.then((response) => response.json())
			.then((response) => {
			  if (response.status) {
				publish(PUB_SUB_EVENTS.cartError, {
				  source: 'product-form',
				  productVariantId: formData.get('id'),
				  errors: response.errors || response.description,
				  message: response.message,
				});
				this.handleErrorMessage(response.description);
  
				const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
				if (!soldOutMessage) return;
				this.submitButton.setAttribute('aria-disabled', true);
				this.submitButton.querySelector('span').classList.add('hidden');
				soldOutMessage.classList.remove('hidden');
				this.error = true;
				return;
			  } else if (!this.cart) {
				window.location = window.routes.cart_url;
				return;
			  }
  
			  if (!this.error)
				publish(PUB_SUB_EVENTS.cartUpdate, {
				  source: 'product-form',
				  productVariantId: formData.get('id'),
				  cartData: response,
				});
			  this.refreshCartQuantity();
				
			  this.error = false;
			  const quickAddModal = this.closest('quick-add-modal');
			  if (quickAddModal) {
				document.body.addEventListener(
				  'modalClosed',
				  () => {
					setTimeout(() => {
					  this.cart.renderContents(response);
					  this.animateCartConfirmation();
					});
				  },
				  { once: true }
				);
				quickAddModal.hide(true);
			  } else {
				this.cart.renderContents(response);
				this.animateCartConfirmation();
			  }
			})
			.catch((e) => {
			  console.error(e);
			})
			.finally(() => {
			  this.submitButton.classList.remove('loading');
			  if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
			  if (!this.error) this.submitButton.removeAttribute('aria-disabled');
			  if (this.querySelector('.loading__spinner')) {
				this.querySelector('.loading__spinner').classList.add('hidden');
			  }
			});
		}
  
		handleErrorMessage(errorMessage = false) {
		  if (this.hideErrors) return;
  
		  this.errorMessageWrapper =
			this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
		  if (!this.errorMessageWrapper) return;
		  this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
  
		  this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

		  if (errorMessage) {
			this.errorMessage.textContent = errorMessage;
		  }
		}
	  }
	);
  }
